import { z } from 'zod';

/**
 * Zod schema for the GET /suppliers/find query parameters.
 */
export const zodFindSuppliersQueryParamsSchema = z.object({
  companyId: z.uuid(),
  creditorNumber: z.string().min(1),
});

/**
 * Zod schema for a single supplier result from the reverse-lookup endpoint
 * (FindPartnerResponse).
 */
export const zodFindPartnerResponseSchema = z.object({
  address: z.object({}).passthrough().nullish(),
  name: z.string().nullish(),
  supplierCompanyId: z.uuid(),
});

/**
 * Zod schema for the GET /suppliers/find response (FindSuppliersResponse).
 */
export const zodFindSuppliersResponseSchema = z.object({
  data: z.array(zodFindPartnerResponseSchema),
});
